import React, { useEffect, useState } from 'react';
import { Bot } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark/80 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-123">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex justify-between items-center" data-id="element-124">
        <div className="flex items-center gap-2" data-id="element-125">
          <Bot className="w-6 h-6 text-cyan-400" data-id="element-126" />
          <span className="font-display font-bold text-xl tracking-tight" data-id="element-127">
            SABER-DIGITAL™
          </span>
        </div>
        <button onClick={scrollToPricing} className="hidden sm:block bg-cyan-400 hover:bg-cyan-300 text-dark font-bold py-2 px-5 rounded-full transition-colors text-sm" data-id="element-128">
          QUIERO MI MEGA PACK
        </button>
      </div>
    </header>;
}